<template>
    <div class="mx-2 flex flex-col gap-1 py-2" v-cloak>

        <div v-if="fetching" class="my-1 flex items-center justify-center gap-2">
            <span class="text-sm text-gray-100">Fetching...</span>
            <spinner />
        </div>

        <div v-if="!fetching" class="flex flex-col gap-1">

            <div class="uppercase text-xs text-center font-semibold mb-2">Users</div>
            <ul class="mb-2 flex flex-col gap-1">
                <li v-for="(item, index) in users" class="flex flex-col mx-2 py-1 px-2 rounded text-sm"
                    :class="index % 2 == 0 ? 'bg-black bg-opacity-10 dark:bg-white dark:bg-opacity-10' : 'dark:bg-white dark:bg-opacity-5'">
                    <div class="flex items-center justify-between">
                        <div class="flex gap-2">
                            <div class="flex items-center justify-center text-gray-500">
                                <img v-if="item.pfp"
                                    class="block rounded-full object-cover h-8 w-8 border-2 border-gray-400 dark:border-white"
                                    :src="item.pfp" />
                                <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="w-8 h-8">
                                    <path fill-rule="evenodd"
                                        d="M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
                                        clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="flex flex-col gap-1">
                                <span class="text-sm text-white">{{ item.name }}</span>
                                <span class="text-xs text-gray-400">{{ item.short_wallet }}</span>
                            </div>
                        </div>
                        <div class="flex flex-col gap-1">
                            <div class="flex items-center justify-end gap-2" @click="toggleUserStatus(item.id)">
                                <span class="text-xs text-gray-300 uppercase">Status</span>
                                <i v-if="item.active" class="fas fa-circle fa-fw text-green-500"></i>
                                <i v-else class="fas fa-circle fa-fw text-red-500"></i>
                            </div>
                            <div class="flex items-center justify-end gap-1 text-white text-sm">
                                <div>{{ item.balance }}</div>
                                <img src="/images/sol.png" class="block h-4 w-4 rounded-full" />
                            </div>
                        </div>
                    </div>
                </li>
            </ul>

        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'AdminSubPanelBots',
    props: ['token'],
    data() {
        return {
            fetching: false,
            users: [],
        }
    },
    mounted() {
        this.fetching = true
        axios.get('/api/admin/users', {
            headers: {
                'Authorization': `Bearer ${this.token}`
            }
        }).then((response) => {
            this.users = response.data.users
        }).catch(() => {
            this.$toast.error('Error fetching Users.')
        }).finally(() => {
            this.fetching = false
        })
    },
    methods: {
        toggleBot(id) {
            for (let i = 0; i < this.users.length; i++) {
                if (this.users[i].id === id) {
                    this.users[i].active = !this.users[i].active;
                    return;
                }
            }
        },
        async toggleUserStatus(id) {
            await axios.post('/api/admin/users/toggle/' + id, null, {
                headers: {
                    'Authorization': `Bearer ${this.token}`
                }
            }).then(() => {
                this.toggleBot(id)
            }).catch(() => {
                this.$toast.error('Error toggling bot.')
            })
        }
    },
}
</script>
